export const getProfileRoutes = ({ urlPrefix = "" }) => [
  {
    title: "Overview",
    route: urlPrefix,
  },
  {
    title: "Settings",
    route: urlPrefix + "/settings",
  },
  {
    title: "Subscription",
    route: urlPrefix + "/subscription",
  },
]
